import { render, staticRenderFns } from "./MicropointCurrentConsume.vue?vue&type=template&id=57491f1a&scoped=true"
import script from "./MicropointCurrentConsume.vue?vue&type=script&lang=js"
export * from "./MicropointCurrentConsume.vue?vue&type=script&lang=js"
import style0 from "./MicropointCurrentConsume.vue?vue&type=style&index=0&id=57491f1a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57491f1a",
  null
  
)

export default component.exports